import { useState } from 'react';
import { faqItems } from '@/mocks/faq';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFaq = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-6 md:px-10 max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-label font-semibold tracking-widest uppercase text-accent-600 bg-accent-100 px-4 py-1.5 rounded-full">
            常见问题
          </span>
          <h2 className="mt-4 text-2xl md:text-3xl font-heading font-semibold text-foreground-950">
            关于抗衰老，你最关心的问题
          </h2>
          <p className="mt-3 text-sm text-foreground-500">
            精选读者最常问的7个问题，为你一一解答
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl overflow-hidden transition-all duration-300"
            >
              <button
                onClick={() => toggleFaq(idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-200/50 transition-colors"
                aria-expanded={openIndex === idx}
              >
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {item.question}
                </span>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-arrow-down-s-line text-lg text-foreground-400 transition-transform duration-300 ${
                      openIndex === idx ? 'rotate-180' : ''
                    }`}
                  ></i>
                </div>
              </button>
              <div
                className={`grid transition-all duration-300 ${
                  openIndex === idx ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                }`}
              >
                <div className="overflow-hidden">
                  <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}